export const AREAS = ['Work', 'Personal', 'Health', 'Social'] as const;
export type FixedArea = (typeof AREAS)[number];
export type Area = string;

export const JOURNAL_TYPES = ['Journal', 'Notes', 'Ideas', 'Brain Dump'] as const;
export type JournalType = (typeof JOURNAL_TYPES)[number];

export const AI_PROVIDERS = ['groq', 'openrouter', 'deepseek'] as const;
export type AIProvider = (typeof AI_PROVIDERS)[number];

export const TASK_STATUS = ['in_progress', 'completed', 'overdue'] as const;
export type TaskStatus = (typeof TASK_STATUS)[number];

export const FOCUS_STATUS = ['running', 'completed', 'cancelled'] as const;
export type FocusStatus = (typeof FOCUS_STATUS)[number];

export const FOCUS_PRESETS = [15, 25, 50] as const;

export const MOOD_RATINGS = [1, 2, 3, 4, 5] as const;
export type MoodRating = (typeof MOOD_RATINGS)[number];

export const STATS_RANGES = [7, 30, 90] as const;
export type StatsRange = (typeof STATS_RANGES)[number];
